import React from 'react';
import { ArrowRight, Star, Shield, Clock, ThumbsUp, CheckCircle2 } from 'lucide-react';
import { Link } from 'react-router-dom';
import { CTASection } from '../components/CTASection';
import { CouponSection } from '../components/CouponSection';
export function HomePage() {
  return <div className="flex flex-col w-full" data-id="element-297">
      {/* Hero Section with Real Image Background */}
      <section className="relative py-24 sm:py-32 overflow-hidden" data-id="element-298">
        {/* Background Image */}
        <div className="absolute inset-0 z-0" style={{
        backgroundImage: 'url("https://images.unsplash.com/photo-1583608205776-bfd35f0d9f83?auto=format&fit=crop&q=80")',
        backgroundPosition: 'center',
        backgroundSize: 'cover'
      }} data-id="element-299" />
        {/* Dark overlay to ensure text readability while keeping it bright */}
        <div className="absolute inset-0 bg-[#0c2340]/70 z-0" data-id="element-300" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0c2340] to-transparent z-0 opacity-80" data-id="element-301" />

        <div className="relative max-w-7xl mx-auto px-4 text-center z-10" data-id="element-302">
          <span className="inline-block py-1.5 px-4 rounded-full bg-white/10 backdrop-blur-sm text-white font-semibold text-sm mb-6 border border-white/20 shadow-sm" data-id="element-303">
            Serving Orange County, CA
          </span>
          <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-white tracking-tight mb-6 max-w-4xl mx-auto leading-tight drop-shadow-lg" data-id="element-304">
            Protect Your Home With{' '}
            <span className="text-[#b87333]" data-id="element-305">Seamless Gutters</span>
          </h1>
          <p className="text-lg sm:text-xl text-slate-200 max-w-2xl mx-auto mb-10 drop-shadow-md" data-id="element-306">
            Professional installation, repair, and maintenance of premium
            aluminum and copper rain gutters for residential and commercial
            properties.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-307">
            <Link to="/appointment" className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-[#b87333] hover:bg-[#a0632a] text-white font-bold py-4 px-8 rounded-lg transition-colors shadow-xl shadow-[#b87333]/30" data-id="element-308">
              Get a Free Estimate
              <ArrowRight className="w-5 h-5" data-id="element-309" />
            </Link>
            <Link to="/services" className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-white/10 hover:bg-white/20 backdrop-blur-md text-white border-2 border-white/50 hover:border-white font-bold py-4 px-8 rounded-lg transition-all" data-id="element-310">
              View Our Services
            </Link>
          </div>
        </div>
      </section>

      {/* Trust Banner - Brightened */}
      <section className="bg-white py-12 border-b border-sky-100 shadow-sm relative z-20 -mt-8 mx-4 sm:mx-8 lg:mx-auto max-w-7xl rounded-2xl" data-id="element-311">
        <div className="px-4" data-id="element-312">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center" data-id="element-313">
            <div className="flex flex-col items-center" data-id="element-314">
              <div className="w-12 h-12 bg-sky-50 rounded-full flex items-center justify-center mb-3" data-id="element-315">
                <Shield className="w-6 h-6 text-[#0c2340]" data-id="element-316" />
              </div>
              <h3 className="font-bold text-slate-900" data-id="element-317">Licensed & Insured</h3>
              <p className="text-sm text-slate-500" data-id="element-318">Full protection</p>
            </div>
            <div className="flex flex-col items-center" data-id="element-319">
              <div className="w-12 h-12 bg-sky-50 rounded-full flex items-center justify-center mb-3" data-id="element-320">
                <Star className="w-6 h-6 text-[#b87333]" data-id="element-321" />
              </div>
              <h3 className="font-bold text-slate-900" data-id="element-322">5-Star Rated</h3>
              <p className="text-sm text-slate-500" data-id="element-323">By local homeowners</p>
            </div>
            <div className="flex flex-col items-center" data-id="element-324">
              <div className="w-12 h-12 bg-sky-50 rounded-full flex items-center justify-center mb-3" data-id="element-325">
                <Clock className="w-6 h-6 text-[#0c2340]" data-id="element-326" />
              </div>
              <h3 className="font-bold text-slate-900" data-id="element-327">Fast Service</h3>
              <p className="text-sm text-slate-500" data-id="element-328">Quick turnaround</p>
            </div>
            <div className="flex flex-col items-center" data-id="element-329">
              <div className="w-12 h-12 bg-sky-50 rounded-full flex items-center justify-center mb-3" data-id="element-330">
                <ThumbsUp className="w-6 h-6 text-[#b87333]" data-id="element-331" />
              </div>
              <h3 className="font-bold text-slate-900" data-id="element-332">100% Guarantee</h3>
              <p className="text-sm text-slate-500" data-id="element-333">Satisfaction promised</p>
            </div>
          </div>
        </div>
      </section>

      {/* Services Overview with Images */}
      <section className="py-24 px-4 bg-slate-50" data-id="element-334">
        <div className="max-w-7xl mx-auto" data-id="element-335">
          <div className="text-center mb-16" data-id="element-336">
            <h2 className="text-3xl sm:text-4xl font-bold text-[#0c2340] mb-4" data-id="element-337">
              Expert Gutter Solutions
            </h2>
            <div className="w-24 h-1 bg-[#b87333] mx-auto rounded-full mb-6" data-id="element-338" />
            <p className="text-lg text-slate-600 max-w-2xl mx-auto" data-id="element-339">
              We offer comprehensive rain gutter services to keep your property
              safe from water damage year-round.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-340">
            {[{
            title: 'Seamless Installation',
            desc: 'Custom-fit aluminum and copper gutters fabricated on-site for a perfect, leak-proof fit.',
            img: 'https://images.unsplash.com/photo-1513694203232-719a280e022f?auto=format&fit=crop&q=80&w=600'
          }, {
            title: 'Gutter Guards',
            desc: 'Premium leaf protection systems to keep debris out and water flowing freely.',
            img: 'https://images.unsplash.com/photo-1515694346937-94d85e41e6f0?auto=format&fit=crop&q=80&w=600'
          }, {
            title: 'Repairs & Maintenance',
            desc: 'Expert fixes for leaks, sagging, and damage to extend the life of your gutters.',
            img: 'https://images.unsplash.com/photo-1504328345606-18bbc8c9d7d1?auto=format&fit=crop&q=80&w=600'
          }].map((service, i) => <div key={i} className="bg-white rounded-2xl overflow-hidden border border-slate-200 hover:shadow-xl transition-all group flex flex-col" data-id="element-341">
                <div className="h-48 overflow-hidden relative" data-id="element-342">
                  <div className="absolute inset-0 bg-[#0c2340]/20 group-hover:bg-transparent transition-colors z-10" data-id="element-343" />
                  <img src={service.img} alt={service.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" data-id="element-344" />
                </div>
                <div className="p-8 flex-grow flex flex-col" data-id="element-345">
                  <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-346">
                    {service.title}
                  </h3>
                  <p className="text-slate-600 mb-6 flex-grow" data-id="element-347">
                    {service.desc}
                  </p>
                  <Link to="/services" className="text-[#b87333] font-semibold flex items-center gap-2 hover:text-[#0c2340] transition-colors mt-auto" data-id="element-348">
                    Learn more <ArrowRight className="w-4 h-4" data-id="element-349" />
                  </Link>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* Lead Magnet / Coupon Section */}
      <CouponSection data-id="element-350" />

      {/* Testimonials - Brightened */}
      <section className="py-24 px-4 bg-white" data-id="element-351">
        <div className="max-w-7xl mx-auto" data-id="element-352">
          <div className="text-center mb-16" data-id="element-353">
            <h2 className="text-3xl sm:text-4xl font-bold text-[#0c2340] mb-4" data-id="element-354">
              What Our Customers Say
            </h2>
            <div className="w-24 h-1 bg-[#b87333] mx-auto rounded-full mb-6" data-id="element-355" />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-356">
            {[{
            name: 'Sarah M.',
            loc: 'Irvine, CA',
            text: 'A-Flow did an amazing job replacing our old gutters. The copper looks beautiful and the crew was incredibly professional.'
          }, {
            name: 'David T.',
            loc: 'Anaheim, CA',
            text: "Got the leaf guards installed before the rainy season. Best decision ever. Haven't had to climb a ladder since!"
          }, {
            name: 'Michael R.',
            loc: 'Newport Beach, CA',
            text: 'Fast, affordable, and high quality. They fabricated everything right in my driveway. Highly recommend their services.'
          }].map((review, i) => <div key={i} className="bg-sky-50/50 p-8 rounded-2xl border border-sky-100 relative" data-id="element-357">
                <div className="flex gap-1 mb-4 text-[#b87333]" data-id="element-358">
                  {[...Array(5)].map((_, j) => <Star key={j} className="w-5 h-5 fill-current" data-id="element-359" />)}
                </div>
                <p className="text-slate-700 italic mb-6" data-id="element-360">"{review.text}"</p>
                <div className="flex items-center gap-3" data-id="element-361">
                  <div className="w-10 h-10 bg-[#0c2340] rounded-full flex items-center justify-center text-white font-bold" data-id="element-362">
                    {review.name.charAt(0)}
                  </div>
                  <div data-id="element-363">
                    <h4 className="font-bold text-slate-900" data-id="element-364">{review.name}</h4>
                    <p className="text-sm text-slate-500" data-id="element-365">{review.loc}</p>
                  </div>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      <CTASection data-id="element-366" />
    </div>;
}